import { render, staticRenderFns } from "./express-applyrejection.vue?vue&type=template&id=2f075199&scoped=true"
import script from "./express-applyrejection.vue?vue&type=script&lang=ts"
export * from "./express-applyrejection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f075199",
  null
  
)

export default component.exports